<template>
  <div id="user-edit-tab-info">
    <div id="studentProfileUpdateLoadingDiv" class="vs-con-loading__container">

      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="data_local.image" class="mr-8 rounded h-24" />
              <div>
                <p class="text-lg font-medium mb-2 mt-8 sm:mt-8">{{ data.name  }} {{ data.last_name  }}</p>
                <span>{{data.lastSeenAgo}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="First Name" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" />
            <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="name" />
            <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
            <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="">
              <template slot="prepend">
                <div class="mt-10 prepend-text bg-primary">
                  <span>+45</span>
                </div>
              </template>

              <vs-input class="w-full mt-4" label="Phone" v-model="data_local.phone" type="phone" v-validate="'required|numeric|digits:8'" name="phone" />
            </vx-input-group>
              <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vue-dawa class="w-full m-0" @select="selectAddressItem($event, 'profileAddressObject')"
              :val="data_local.one_line_address"
              :showMax="5"
              placeholder=""
              containerId="settingAddressContainer"
              fieldClasses="vs-inputx vs-input--input normal w-full"
              fieldId="your-field-id"
              ref="your-field-id"
              fieldName="your-field-name">
              <label slot="label-top" for="field-2">Address</label>
            </vue-dawa>
          </div>
        </div>

        <vs-divider/>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <label>Phone number</label>
            <vs-switch v-model="verify">
                <span slot="on">Verified</span>
                <span slot="off">Not Verified</span>
            </vs-switch>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label>Email</label>
            <vs-switch v-model="email_verify">
                <span slot="on">Verified</span>
                <span slot="off">Not Verified</span>
            </vs-switch>
          </div>
        </div>

        <vs-divider/>
        
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-full mt-base mb-base">
            <vs-switch @input="updateUserStatus" style="width: 70px;" color="success" v-model="status">
                <span slot="on">Active</span>
                <span slot="off"> In active</span>
            </vs-switch>
          </div>
        </div>
        
        <vs-divider/>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Password" v-validate="'min:6|max:12'" name="password" ref="password" v-model="data_local.password"  />
            <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Confirm Password" v-validate="getValidationCP" name="confirm_password" ref="confirm_password" v-model="data_local.confirm_password"  />
            <span class="text-danger text-sm"  v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto mt-2" color="danger" @click="openDeleteStudentConfirm">Delete Student</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
              <vs-button class="ml-4 mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import VueDawa from '@ancaio/vue-dawa/sfc'

export default {
  components: {
    vSelect,
    VueDawa
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local : {
        password : ""
      },
      data_local: JSON.parse(JSON.stringify(this.data)),
      verify: (this.data.verify == "1") ? true : false,
      email_verify: (this.data.email_verify == "1") ? true : false,
      isProfileImageChanged : false,
      status: (this.data.status == "active") ? true : false,
      oneLineAddress : this.data.one_line_address,
    }
  },
  computed: {
    getValidationCP() {
      if(this.data_local.password && this.data_local.password != ""){
        return 'required|min:6|max:12|confirmed:password'
      }
      else return 'min:6|max:12|confirmed:password' 
    },
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    selectAddressItem (payload, objectName) {
      this.oneLineAddress = payload.oneLineAddress
    },
    openDeleteStudentConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure to comfirm to delete this student ?',
        accept: this.acceptAlert
      })
    },
    acceptAlert() {
      this.$vs.loading({ color: '#ff8000' })

      this.$store.dispatch("userManagement/deleteStudent", this.data_local.id)
        .then(res => { 
          this.$vs.loading.close()

          this.$router.push("/students").catch(() => {})

          this.$vs.notify({
            title: "Success.",
            text: "Student deleted successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    save_changes() {
      this.$validator.validateAll().then(result => {
        if (result) this.update_user()
      })
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
    updateUserStatus() {
      var self = this
      this.$vs.loading({
        container: '#studentProfileUpdateLoadingDiv',
        scale: 0.6
      })

      let data = { 
        student_id : this.data_local.id,
        status : (this.status) ? 'active' : 'blocked',
      }

      this.$store.dispatch("userManagement/updateUserStatus", data)
        .then(res => { 
          this.$vs.loading.close('#studentProfileUpdateLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Student updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#studentProfileUpdateLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    update_user() {
      var self = this
      
      this.$vs.loading({
        container: '#studentProfileUpdateLoadingDiv',
        scale: 0.6
      })

      let data = {
        name : this.data_local.name,
        last_name : this.data_local.last_name,
        email : this.data_local.email,
        phone : this.data_local.phone,
        student_id : this.data_local.id,
        verify : (this.verify) ? '1' : '0',
        email_verify : (this.email_verify) ? '1' : '0',
        one_line_address : this.oneLineAddress,
      }

      // if(this.isProfileImageChanged){
      //   var reader = new FileReader();
      //   var image = null;

      //   reader.readAsDataURL(this.data_local.image); 
      //   reader.onloadend = function() {
      //       var base64data = reader.result;    
      //       image = base64data            
      //       console.log(base64data);
      //       return;
      //   }

      //   var reader = new FileReader();
      //   reader.readAsDataURL(this.data_local.image); 
      //   reader.onloadend = function() {
      //     var base64data = reader.result;                
      //   }

      //   //  var reader = new FileReader();
      //   //  reader.readAsDataURL(this.data_local.image); 
      //   //  reader.onloadend = function() {
      //   //      var base64data = reader.result;                
      //   //      console.log(base64data);
      //   //  }

      //   console.log("kkk")
      //   console.log(this.data_local.base64_image)
      //   data.base64_image = this.data_local.base64_image
      // } 
      // else console.log("hhh")

      if(this.data_local.password != true && this.data_local.password != "") data.password = this.data_local.password

      this.$store.dispatch("userManagement/updateStudent", data)
        .then(res => { 
          this.$vs.loading.close('#studentProfileUpdateLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Student updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#studentProfileUpdateLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    // change_image(self) {
    //   var reader = new FileReader();
    //   const self = 5;
    //   reader.onloadend = function(self) {
    //     // console.log(reader.result)
    //     self = 10;

    //     // this.data_local.image = reader.result
    //   }

    // },
    async update_avatar(e) {
      const file = e.target.files[0];
      this.isProfileImageChanged = true
      this.data_local.image = URL.createObjectURL(file);

      var reader = new FileReader();
      var self = 5;
      reader.onloadend =   function(self) {
        // console.log(reader.result)
        self = 10;
        return 
        // return self
        // this.data_local.image = reader.result
      }

      // console.log(self)
      console.log(self)
      // console.log(reader.result)
      reader.readAsDataURL(file);
    }
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  }
}
</script>
